import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AddCall } from 'src/providers/addvCall';
import { CommonService } from 'src/providers/common';
import { ServicesProvider } from 'src/providers/services';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-common-notification',
  templateUrl: './common-notification.page.html',
  styleUrls: ['./common-notification.page.scss'],
})
export class CommonNotificationPage implements OnInit {

  ModuleName: any;
  Modulesrc: any;
  moduleid: any;
  notificationdetails: any = [];
  EmptyData: any;
  patientGender: any;
  previousData: any = [];
  oneWeekAgoData: any = [];
  currentDateData: any = [];
  patientIdLocal: any;
  patient_id: any;
  constructor(
    public router: Router,
    public active: ActivatedRoute,
    private services: ServicesProvider,
    public common: CommonService,
    public addCall: AddCall,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
  }



  ionViewWillEnter() {

    this.common.videoSound = false;
    this.common.setDoctorDetails(false);
    console.log(this.common.videoSound, "VideoSound");
    this.Modulesrc = this.common.profileImage;
    this.patientGender = localStorage.getItem("Gender");
    console.log('check notification');
    console.log(this.active.snapshot.paramMap.get('module'));
    this.ModuleName = this.active.snapshot.paramMap.get('module');
    // this.Modulesrc = this.active.snapshot.paramMap.get('modulepic')
    this.moduleid = this.active.snapshot.paramMap.get('moduleid');
    this.patient_id = this.active.snapshot.paramMap.get('patient_id');
    console.log(this.moduleid);
    console.log(this.patient_id);
    if (this.patient_id){
      this.patientIdLocal = this.patient_id;
    }else{
      this.patientIdLocal = localStorage.getItem("patient_id");
    }


    let apidata = JSON.stringify({
      "memberId": this.patientIdLocal,
      "moduleId": this.moduleid == null ? 0 : this.moduleid,
      "notificationDate": new Date().toISOString().split("T")[0]
    })

    this.services.postRequest("getMemberNotifications", apidata).subscribe(res => {
      // console.log(res,"check response");
      this.notificationdetails = res.data;
      this.EmptyData = res.status;
      console.log(this.notificationdetails);

      const currentDate = new Date(); // Current date
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(currentDate.getDate() - 7); // One week ago

      this.currentDateData = [];
      this.oneWeekAgoData = [];
      this.previousData = [];

      const data = this.notificationdetails;

      data.forEach(item => {
        const notificationDate = new Date(item.notification_date);

        if (notificationDate.toDateString() === currentDate.toDateString()) {
          this.currentDateData.push(item);
        } else if (notificationDate > oneWeekAgo && notificationDate < currentDate) {
          this.oneWeekAgoData.push(item);
        } else {
          this.previousData.push(item);
        }
      });

      console.log('Current Date Data:', this.currentDateData);
      console.log('One Week Ago Data:', this.oneWeekAgoData);
      console.log('Previous Data:', this.previousData);
      this.currentDateData = this.currentDateData.sort((a:any, b:any) => b.id - a.id);

    })

    localStorage.getItem("Gender");
    console.log("Gender", localStorage.getItem("Gender"))

    this.patientGender = localStorage.getItem("Gender");



  }
  goBack() {
    this.notificationdetails = []
    this.router.navigate(['/tabs/home']);
  }

  navToRefferal(frmref, typeId, id, vendor_type_id) {
    debugger;
    console.log(frmref)

    if (frmref == 'ReferralLab') {
      console.log("check");
      localStorage.setItem("frmPage", "labreferral");
      this.router.navigate(['/tabs/appointments'])
    } 
    else if (frmref == 'Referral' && typeId == 1) {
      localStorage.setItem("frmPage", "referral");
      this.router.navigate(['/tabs/appointments'])
    } 
    else if (frmref == 'Referral' && typeId == 12) {
      localStorage.setItem("frmPage", "RefPhysio");
      this.router.navigate(['/tabs/appointments'])
    } 
    else if ((frmref == "OutforDelivery" || frmref == "SendQuote") && typeId == 9 && id) {
      this.router.navigate(['tabs/prescription', { frmPage: 'payment', prcId: id }]);
    } 
    else if ((frmref == "Booking" || frmref == "Rescheduled") && vendor_type_id == "1") {
      localStorage.setItem("notificationActiveMenuId", "1");
      this.router.navigate(['tabs/appointments']);
    } 
    else if ((frmref == "Booking" || frmref == "Rescheduled") && vendor_type_id == "2") {
      localStorage.setItem("notificationActiveMenuId", "2");
      this.router.navigate(['tabs/appointments']);
    } 
    else if ((frmref == "Booking" || frmref == "Rescheduled") && vendor_type_id == "12") { 
      localStorage.setItem("notificationActiveMenuId", "12");
      this.router.navigate(['tabs/appointments']);
    } 
    else if ((frmref == "Booking" || frmref == "CheckOut" || frmref == "TaskCompleted" || frmref == "CheckIn") && vendor_type_id == "5") { 
      localStorage.setItem("notificationActiveMenuId", "5");
      this.router.navigate(['tabs/appointments']);
    } 
    else if ((frmref == "Booking" || frmref == "Rescheduled") && vendor_type_id == "7") { 
      localStorage.setItem("notificationActiveMenuId", "7");
      this.router.navigate(['tabs/appointments']);
    } 
    else if ((frmref == "Booking" || frmref == "Rescheduled") && vendor_type_id == "6") { 
      localStorage.setItem("notificationActiveMenuId", "6");
      this.router.navigate(['tabs/appointments']);
    } 
    else if ((frmref == "Booking" || frmref == "Rescheduled") && vendor_type_id == "10") { 
      localStorage.setItem("notificationActiveMenuId", "10");
      this.router.navigate(['tabs/appointments']);
    } 
    else if ((frmref == "Booking" || frmref == "Rescheduled") && vendor_type_id == "8") { 
      localStorage.setItem("notificationActiveMenuId", "8");
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "Ticket") {
      this.router.navigate(['tabs/chat']);
    } 
    else if (frmref == "TodayBooking") {
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "Cancel" && typeId == 12) {
      localStorage.setItem("frmPage", "PhysioHis");
      this.router.navigate(['/tabs/appointments'])
    } 
    else if (frmref == "Cancel" && typeId == 1) {
      localStorage.setItem("frmPage", "docHis");
      this.router.navigate(['/tabs/appointments'])
    } 
    else if (frmref == "CheckIn" && typeId == 12) {
      localStorage.setItem("notificationActiveMenuId", "12");
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "CheckIn") {
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "ReminderVC" && typeId == 12) {
      localStorage.setItem("notificationActiveMenuId", "12");
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "ReminderVC" && typeId == 6) {
      localStorage.setItem("notificationActiveMenuId", "6");
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "ReminderVC") {
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "Queue" && typeId == 12) {
      localStorage.setItem("notificationActiveMenuId", "12");
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "Queue") {
      this.router.navigate(['tabs/appointments']);
    } 
    else if ((frmref == false || frmref == null) && vendor_type_id == "0") {
      this.router.navigate(['tabs/appointments']);
    } 
    else if (frmref == "Upload" && vendor_type_id == "2") { 
      this.router.navigate(['tabs/report']); 
    } 


  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }
    var Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        var hourEnd = Value.indexOf(":");
        var H = +String(Value).substr(0, hourEnd);
        var h = H % 12 || 12;
        var ampm = (H < 12 || H === 24) ? "am" : "pm";
        // var ampm = (H < 12 || H === 24) ? this.addCall.title458 : this.addCall.title459;
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }
        return timeString;
      case "Date":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else {
          let dateCall = new Date(dateTime);
          var months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          var days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
          var arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }


      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yy h:mm a");
    }
  }
  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }
}
